import { useState } from "react";
import { readStoredToken } from "../AuthState";

export default function useToken() {
  const getToken = () => {
    return readStoredToken();
  };

  const [token, setToken] = useState(getToken());

  const saveToken = (userToken) => {
    localStorage.setItem("token", JSON.stringify(userToken));
    setToken(userToken);
  };

  return {
    setToken: saveToken,
    token,
  };
}
